import { render, staticRenderFns } from "./BalanceByYear.vue?vue&type=template&id=3562d1e2"
import script from "./BalanceByYear.vue?vue&type=script&lang=js"
export * from "./BalanceByYear.vue?vue&type=script&lang=js"
import style0 from "./BalanceByYear.vue?vue&type=style&index=0&id=3562d1e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports